module.exports = __webpack_public_path__ + "img/msi.361a6913.png";